import { FC } from 'react';
import { CardImage, IconAndText, Link } from '@blueprint/ui';
import {
    StyledCard,
    PropertyDetails,
    StyledPropertyTitle,
    StyledPropertyAddress,
    AgentImage,
    PropertyDetailsContainer,
    PropertyImage,
    StyledPropertyPrice,
    FeatureWrapper,
    AgentImageWrapper,
    StyledPropertySubPrice
} from './FeaturedProperties.styles';
import { FeaturedPropertyData } from './FeaturedProperties.types';

export type Props = {
    property: FeaturedPropertyData;
    onClick?: () => void;
};

const FeaturedPropertyCard: FC<Props> = (props) => {
    const { property, onClick } = props;
    const queryString = `?${property.featuredType}=1&utm_content=featured_listing`;
    const detailsLink = props.property.listingUris?.detail
        ? `${props.property.listingUris?.detail}${queryString}`
        : '#';

    const availableFeatures = property.features.filter(
        (feature) => feature.content > 0
    );

    return (
        <Link
            plain
            href={detailsLink}
            key={property.listingId}
            onClick={onClick}
            data-testid="featured-property-card"
        >
            <StyledCard
                hasShadow={false}
                hasBorder={false}
                hasBackground
                contentAlignment="left"
            >
                <PropertyImage>
                    <CardImage
                        src={property.image.src}
                        responsiveImgList={property.image.responsiveImgList}
                    />
                </PropertyImage>
                <PropertyDetailsContainer>
                    <PropertyDetails>
                        <StyledPropertyTitle
                            color="text-placeholder"
                            isBold
                            size="secondary"
                        >
                            {property.title}
                        </StyledPropertyTitle>

                        <StyledPropertyPrice color="text-title" size="7" isBold>
                            {property.price}
                        </StyledPropertyPrice>
                        {property.alternativeRentFrequencyLabel && (
                            <StyledPropertySubPrice
                                color="text-placeholder"
                                size="secondary"
                                isBold
                                data-testid={'sub-price'}
                            >
                                {property.alternativeRentFrequencyLabel}
                            </StyledPropertySubPrice>
                        )}

                        <StyledPropertyAddress
                            color="text-body"
                            size="secondary"
                        >
                            {property.address}
                        </StyledPropertyAddress>
                        <FeatureWrapper>
                            {availableFeatures.map((item, index) => {
                                const { iconId, content } = item;

                                return (
                                    <IconAndText
                                        isInline
                                        key={`${index}-${iconId}`}
                                        iconId={iconId}
                                        content={content}
                                        iconColor={'grey-steel'}
                                        contentColor={'grey-slate'}
                                        size="medium"
                                    />
                                );
                            })}
                        </FeatureWrapper>
                    </PropertyDetails>
                    <AgentImageWrapper>
                        <AgentImage
                            src={property.branch.logoUrl}
                            alt={property.branch.name}
                        />
                    </AgentImageWrapper>
                </PropertyDetailsContainer>
            </StyledCard>
        </Link>
    );
};

export default FeaturedPropertyCard;
